/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Channel_Zalo_Mini_AppInputs */

const vi_order_channel_zalo_mini_app = /** @type {(inputs: Order_Channel_Zalo_Mini_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zalo Mini App`)
};

/**

* @param {Order_Channel_Zalo_Mini_AppInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_channel_zalo_mini_app = /** @type {((inputs?: Order_Channel_Zalo_Mini_AppInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Channel_Zalo_Mini_AppInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_channel_zalo_mini_app(inputs)
});